import { Component, OnInit,HostListener } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { Http, Response,Headers } from '@angular/http';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import {MatSnackBar} from '@angular/material';
import {SnackbarComponent} from '../snackbar/snackbar.component';
class Data {};
@Component({
  selector: 'app-unblockuser',
  templateUrl: './unblockuser.component.html',
  styleUrls: ['./unblockuser.component.css'],
  providers: [HelperService] 
})
export class UnblockuserComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
	localStorage.removeItem('access_token');
	localStorage.removeItem('navigateroute');
  }
  parentid;
  dtTrigger: Subject<any> = new Subject();
  datas: Data[] = [];
  dtOptions: DataTables.Settings = {order:[]};
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private activatedRoute: ActivatedRoute,private router: Router,private http:Http,private helper:HelperService,private snackbar: MatSnackBar) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.parentid = params['parentid'];
      // this.packageid = params['packageid'];
       //alert(this.parentid);
      // alert(this.packageid);
    });
    this.http.get(this.helper.base_url+'http/get/unblockdevices/'+this.parentid,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
      
        this.datas = data;        
        this.dtTrigger.next();
        
       
      });
  }
  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }
  delete_form(id){
          
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
    //this.snackbar.open('Are you sure!', 'Delete', {
      duration: 5000,
      extraClasses:  ['warning-snackbar'],
    }).onAction().subscribe(() => {
      this.http.get(this.helper.base_url+'http/delete/userdevice/'+id,{ headers: this.headers })
      .subscribe(
         
          (data) => {
            let body = JSON.parse(data['_body']);
            //console.log(body)
            if(body.success == 1)
            {
              //this.listClick(null) ;
              this.refresh(false,body.message) ;
            }
            else
            {
              this.snackbar.open(body.message, null, {
                duration:5000,
                  extraClasses:'error-snackbar',
                  verticalPosition:'top'
                });
            }
            //this.refresh(false,'Parent deleted Successfully')
          }, //For Success Response
          err => {console.error(err)} //For Error Response
      ); 
    });
   
  }
  refresh(val=false,msg=''){
    this.snackbar.open(msg, null, {
      duration:5000,
        extraClasses:'success-snackbar',
        verticalPosition:'top'
      });
    this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
    this.router.navigate(["/appusers"]));
    
        
   }

}



// WEBPACK FOOTER //
// ./src/app/unblockuser/unblockuser.component.ts